var React = require('react');

function Data (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M10 0a10 10 0 1 0 0 20 10 10 0 0 0 0-20ZM2 10c0-.6 0-1.2.2-1.8L7 13v1c0 1.1.9 2 2 2v2a8 8 0 0 1-7-8Zm13.9 5.4a2 2 0 0 0-2-1.4h-1v-3c0-.6-.4-1-1-1H6V8h2c.6 0 1-.5 1-1V5h2a2 2 0 0 0 2-2v-.4a8 8 0 0 1 3 12.8Z","fill":"#7A7A7A"}));
}

Data.defaultProps = {"width":"20","height":"20","fill":"none"};

module.exports = Data;

Data.default = Data;
